<template>
  <!-- 为 ECharts 准备一个定义了宽高的 DOM -->
  <div ref="chart" style="width: 100%;"></div>
</template>

<script>
// import * as echarts from 'echarts/core'
import * as echarts from "echarts";
export default {
  name: "lineChart",
  data() {
    return {};
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const travelData = {
        xdata: [
          "0点~2点",
          "3点~5点",
          "6点~8点",
          "0点~2点",
          "3点~5点",
          "6点~8点",
          "0点~2点",
          "3点~5点"
        ],
        ydata: [200, 85, 112, 275, 305, 415, 741, 405]
      };
      const myChart = echarts.init(this.$refs.chart);
      // 指定图表的配置项和数据
      const option = {
        // backgroundColor: "#031245",
        //  backgroundColor: '#fff',
        title: {
          show: true,
          text: "商户城市统计",
          left: "center"
          // left: 40 + "%",
        },
        color: ["#63caff", "#3608FE"],
        grid: {
          containLabel: true,
          left: 10,
          right: 10,
          bottom: 10,
          top: 40
        },
        xAxis: {
          axisLabel: {
            color: "#c0c3cd",
            fontSize: 14,
            interval: 0
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#384267",
              width: 1,
              type: "dashed"
            },
            show: true
          },
          data: travelData.xdata,
          type: "category"
        },
        yAxis: {
          axisLabel: {
            color: "#c0c3cd",
            fontSize: 14
          },

          splitLine: {
            show: true,
            lineStyle: {
              color: "#384267",
              type: "dashed"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#384267",
              width: 1,
              type: "dashed"
            },
            show: true
          },
          name: ""
        },
        series: [
          {
            data: travelData.ydata,
            type: "bar",
            barWidth: 30,
            itemStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                type: "linear",
                global: false,
                colorStops: [
                  {
                    offset: 0,
                    color: "#3A1BFD"
                  },
                  {
                    offset: 1,
                    color: "#3BEFFD"
                  }
                ]
              }
            },
            label: {
              show: true,
              position: "top",
              distance: 10,
              color: "#fff"
            }
          },
          {
            data: [1, 1, 1, 1, 1, 1, 1, 1],
            type: "pictorialBar",
            barMaxWidth: "20",
            symbol: "diamond",
            symbolOffset: [0, "50%"],
            symbolSize: [30, 15]
          },
          {
            data: travelData.ydata,
            type: "pictorialBar",
            barMaxWidth: "20",
            symbolPosition: "end",
            symbol: "diamond",
            symbolOffset: [0, "-50%"],
            symbolSize: [30, 12],
            zlevel: 2
          }
        ],
        tooltip: {
          trigger: "item",
          show: true
        }
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/statistics/sales/part/SalesAnalysis/echartone.vue